export const EMAIL_INBOX_REQUESTS = [
  '/email/accounts',
  '/email/user-labels',
  '/email/views/all/messages?max_results=50&folder_id=INBOX',
] as const;

/** Read only the private inbox and the message named by its canonical route. */
export function emailInboxBootRequests(
  route: readonly string[],
  search: string
): readonly string[] {
  if (route.length === 0 && !search) return EMAIL_INBOX_REQUESTS;
  if (route[0] !== 'all-accounts' || route[1] !== 'inbox') return [];
  if (route.length === 2 && !search) return EMAIL_INBOX_REQUESTS;
  const encodedMessageId = route[2];
  if (route.length !== 3 || !encodedMessageId) return [];

  const query = new URLSearchParams(search);
  const accountId = query.get('sourceAccount');
  if (
    query.size !== 1 ||
    !accountId ||
    !/^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i.test(accountId)
  ) {
    return [];
  }
  try {
    const messageId = decodeURIComponent(encodedMessageId);
    if (!messageId) return [];
    return [
      ...EMAIL_INBOX_REQUESTS,
      `/email/accounts/${accountId}/messages/${encodeURIComponent(messageId)}`,
    ];
  } catch {
    return [];
  }
}
